import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LocaleProvider } from './i18n';
import { AuthProvider } from './hooks/useAuth';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initSentry } from './lib/sentry';
import { Toaster } from 'sonner';
import '@bookquest/design-tokens/css';
import './styles/global.css';

// Initialize before React mounts so component-tree errors get captured.
initSentry();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <LocaleProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
            <Toaster
              position="bottom-right"
              theme="light"
              richColors={false}
              toastOptions={{
                style: {
                  background: 'var(--bq-color-surface-raised)',
                  border: '1px solid var(--bq-color-border-default)',
                  borderRadius: 'var(--bq-radius-md)',
                  color: 'var(--bq-color-text-primary)',
                  fontFamily: "'Inter', 'Pretendard', sans-serif",
                  boxShadow: 'var(--bq-shadow-lg)',
                },
              }}
            />
          </AuthProvider>
        </BrowserRouter>
      </LocaleProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
